import { Component, OnInit } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { ExampleService } from 'src/app/services/example/example.service';

@Component({
  selector: 'app-example-card',
  templateUrl: './example-card.component.html',
  styleUrls: ['./example-card.component.scss'],
})
export class  ExampleCardComponent implements OnInit {

    example$ = new BehaviorSubject<string | undefined>(undefined);

  constructor(
    private _exampleService: ExampleService
    ) {

  }

  ngOnInit() {

      this._exampleService.getStuff$.subscribe(list => {
          this.example$.next(list[1].myString);
    });
  }
}
